module.exports = __webpack_public_path__ + "media/recipes/25-85ba6bb9.png";